import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import StyleWrapper from "components/Global/Modal/Layout/StyleWrapper";
import { showSnackbar } from "redux/modules/snackbar/actions";
import dashboardApi from "EventLight/Common/Dashboard/api";
import { getCredentials } from "redux/modules/user/selectors";
import { BigFilledButton, BigOutlineButton } from "components/Base";
import { INDUCTION_MESSAGE_STATUS } from "./constants";
import InductionMessage from "./InductionMessage";

const SendInductionForm = ({
  closeModal,
  selectedContactIds,
  showSnackbar,
  userCredentials,
  eventId,
  fetchData,
  resendTo = "",
  sendTo = ""
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      const { success, payload } = await dashboardApi.sendInductionFormInvite(
        userCredentials,
        {
          contactIds: selectedContactIds,
          eventId,
          message: "You are invited to fill out the induction form!"
        }
      );

      if (success) {
        showSnackbar({
          message: payload.message || "Induction form sent successfully",
          variant: "success"
        });
        fetchData();
        closeModal();
      }
    } catch (error) {
      showSnackbar({
        message: error.message || "Failed to send induction form",
        variant: "error"
      });
      setIsSubmitting(false);
    }
  };

  return (
    <StyleWrapper
      heading={resendTo ? "Resend Induction Form" : "Send Induction Form"}
      hideModal={closeModal}
      width={500}
      bodyStyles={{}}
      containerStyles={{}}
      data-cy="send-induction-form-modal"
    >
      <InductionMessage
        status={
          sendTo
            ? INDUCTION_MESSAGE_STATUS.SEND
            : resendTo
            ? INDUCTION_MESSAGE_STATUS.RESEND
            : INDUCTION_MESSAGE_STATUS.BULK
        }
        name={sendTo || resendTo}
        count={selectedContactIds.length}
      />
      <div style={{ display: "flex", gap: 10 }}>
        <BigOutlineButton width={1} onClick={closeModal}>
          Cancel
        </BigOutlineButton>
        <BigFilledButton
          bg="altB5"
          width={1}
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Sending..." : "Send"}
        </BigFilledButton>
      </div>
    </StyleWrapper>
  );
};

SendInductionForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  selectedContactIds: PropTypes.array.isRequired,
  showSnackbar: PropTypes.func.isRequired,
  userCredentials: PropTypes.object.isRequired,
  eventId: PropTypes.string,
  orgId: PropTypes.string,
  moduleId: PropTypes.string,
  fetchData: PropTypes.func.isRequired,
  resend: PropTypes.bool
};

export default connect(
  state => ({
    userCredentials: getCredentials(state)
  }),
  { showSnackbar }
)(SendInductionForm);
